import React from "react";
import {
  Modal,
  Box,
  Typography,
  Button,
  CircularProgress,
} from "@mui/material";
import { Cancel, CheckCircleOutline } from "@mui/icons-material";

interface SubmissionModalProps {
  open: boolean;
  submitting?: boolean;
  success?: boolean;
  error?: string | null;
  successTitle?: string;
  successMessage?: string;
  onClose: () => void;
  onSuccessClose?: () => void;
  onSuccessAction?: () => void;
  successActionText?: string;
}

const SubmissionModal: React.FC<SubmissionModalProps> = ({
  open,
  submitting = false,
  success = false,
  error = null,
  successTitle = "Success",
  successMessage = "The action was completed successfully.",
  onClose,
  onSuccessClose,
  onSuccessAction,
  successActionText = "View Details",
}) => {
  return (
    <Modal
      open={open}
      onClose={success ? onSuccessClose || onClose : onClose}
      disableEscapeKeyDown={!!success}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 350,
          bgcolor: "background.paper",
          borderRadius: 2,
          boxShadow: 24,
          p: 3,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {submitting && <CircularProgress sx={{ mb: 2 }} />}

        {!submitting && error && !success && (
          <>
            <Cancel sx={{ color: "red", fontSize: 40, mb: 2 }} />
            <Typography
              color="error"
              variant="body1"
              sx={{ mb: 2, textAlign: "center" }}
            >
              {error}
            </Typography>
            <Button onClick={onClose} sx={{ width: "100%" }}>
              Close
            </Button>
          </>
        )}

        {!submitting && success && !error && (
          <>
            <CheckCircleOutline sx={{ color: "green", fontSize: 40, mb: 2 }} />
            <Typography
              variant="h6"
              sx={{ fontWeight: "bold", mb: 1, textAlign: "center" }}
            >
              {successTitle}
            </Typography>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ mb: 2, textAlign: "center" }}
            >
              {successMessage}
            </Typography>
            {onSuccessAction && (
              <Button
                variant="contained"
                color="primary"
                sx={{ mb: 1, width: "100%" }}
                onClick={onSuccessAction}
              >
                {successActionText}
              </Button>
            )}
            <Button onClick={onSuccessClose || onClose} sx={{ width: "100%" }}>
              Close
            </Button>
          </>
        )}

        {!submitting && !success && !error && (
          <Button onClick={onClose} sx={{ width: "100%" }}>
            Close
          </Button>
        )}
      </Box>
    </Modal>
  );
};

export default SubmissionModal;
